export class GetTableDataQualityQuarantineBatchResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "batch",
            "baseName": "batch",
            "type": "QuarantineBatch",
            "format": ""
        },
        {
            "name": "sampleRows",
            "baseName": "sampleRows",
            "type": "Array<QuarantineSampleRow>",
            "format": ""
        },
        {
            "name": "triggers",
            "baseName": "triggers",
            "type": "Array<TriggeredAction>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableDataQualityQuarantineBatchResponse.attributeTypeMap;
    }
    constructor() {
    }
}
